import LocalizedStrings from 'react-localization';

export default new LocalizedStrings({
    en: {
        uploadFileError: 'error uploading',
        sameFileTypeError: 'not same file type',
        shareable: 'Shareable',
        tags: 'Tags',
        updateFile: 'Update File',
        browseFiles: 'Browse Files',
        delete: 'Delete',
        deleteFile: 'Delete File/s',
        deleteFileMessage: 'Are you sure you want to delete this file?',
        deleteMultipleFilesMessage: 'Are you sure you want to delete all selected files?',
        yes: 'Yes',
        no: 'No',
        saveBookmarkExplanation: 'Please write a name for this Bookmark:',
        saveBookmarkNote: '* if the name exists the current bookmark will be overwritten',
        cancel: 'Cancel',
        confirm: 'Confirm',
        mandatoryGroupFilter: "mandatory, owned by metadocument's group or by nobody",
        existingTags: 'Existing tags',
        uploadedBy: 'Uploaded By',
        me: 'me',
        userGroup: 'User Group',
        fileNameBeginsWith: 'File name begins with',
        searchPlaceholder: 'Search...',
        file: 'File',
        image: 'Image',
        video: 'Video',
        files: 'Files',
        images: 'Images',
        videos: 'Videos',
        mostUsedFiles: 'Most used files',
        savedSearches: 'Saved Searches',
        sessions: 'Sessions',
        name: 'Name',
        use: 'Use',
        date: 'Date',
        menu: 'Menu',
        tagSelected: 'Tag Selected',
        deleteSelected: 'Delete Selected',
        chooseFile: 'Choose file/files',
        loadMore: 'Load more results',
        addUsergroup: 'Add a usergroup',
        dragDropZone: 'Drag & Drop area',
        upload: 'Upload',
        cancelAction: 'Cancel Action',
        cancelActionMessage: 'Are you sure you want to cancel the upload? All changes will be lost.',
        error: 'Error',
        uploadErrorMessage: 'To begin the upload you must select at least one file and have at least one tag defined for them.',
        ok: 'Ok',
        createTag: 'Create tag',
        tagFilesPlaceholder: 'Tag your files...',
        pleaseTagSelection: 'Please tag the selected files:',
        tagSelectedNote: '* if a tag is repeated in a file it will be ignored for that file',
        usedCount: 'Used count:',
        metadocument: 'Metadocument',
        preview: 'Preview',
        search: 'Files',
        library: 'Library',
        session: 'Session',
        noResults: '-- No results --',
        shareableTitle: 'Please confirm if these files must be shareable or not:',
        shareableDescription: 'Please check the box below, or not, depending on if the file must be shareable or not',
        md5Title: 'Files Already in Library',
        md5Message: 'The following files are already uploaded in Library, do you want to upload them again?',
    },
    es: {
        uploadFileError: 'error subiendo ficheros',
        sameFileTypeError: 'tipo de fichero diferente',
        shareable: 'Compartible',
        tags: 'Tags',
        updateFile: 'Subir Fichero',
        browseFiles: 'Escoger Ficheros',
        delete: 'Borrar',
        deleteFile: 'Borrar Fichero/s',
        deleteFileMessage: '¿Está seguro de que quiere borrar el fichero?',
        deleteMultipleFilesMessage: '¿Está seguro de que quiere borrar todos los ficheros seleccionados?',
        yes: 'Sí',
        no: 'No',
        saveBookmarkExplanation: 'Por favor escriba un nombre para el Marcador (tag):',
        saveBookmarkNote: '* si el nombre existe, el marcador (tag) se sobreescribirá',
        cancel: 'Cancelar',
        confirm: 'Confirmar',
        mandatoryGroupFilter: 'obligatorio, propiedad del grupo del metadocumento o de nadie',
        existingTags: 'Tags existentes',
        uploadedBy: 'Subido Por',
        me: 'yo',
        userGroup: 'Grupo de Usuarios',
        fileNameBeginsWith: 'El nombre del fichero empieza por',
        searchPlaceholder: 'Buscar...',
        file: 'Fichero',
        image: 'Imagen',
        video: 'Video',
        files: 'Ficheros',
        images: 'Imágenes',
        videos: 'Videos',
        mostUsedFiles: 'Ficheros más usados',
        savedSearches: 'Búsquedas Guardadas',
        sessions: 'Sesiones',
        name: 'Nombre',
        use: 'Uso',
        date: 'Fecha',
        menu: 'Menú',
        tagSelected: 'Tag Seleccionado',
        deleteSelected: 'Borrar Seleccionados',
        chooseFile: 'Escoja fichero/s',
        loadMore: 'Cargar más resultados',
        addUsergroup: 'Añadir a grupo de usuarios',
        dragDropZone: 'Área para arrastrar y soltar',
        upload: 'Subir',
        cancelAction: 'Cancelar Acción',
        cancelActionMessage: '¿Está seguro de que desea cancelar la subida? Todos los cambios se perderán.',
        error: 'Error',
        uploadErrorMessage: 'Para empezar la subida tiene que escoger por lo menos un fichero y definir al menos un tag.',
        ok: 'Ok',
        createTag: 'Crear tag',
        tagFilesPlaceholder: 'Pon tag a los ficheros...',
        pleaseTagSelection: 'Por favor, pon tags a los ficheros seleccionados:',
        tagSelectedNote: '* si un tag se repite en un fichero, se ignorará para ese fichero',
        usedCount: 'Contador de uso:',
        metadocument: 'Metadocumento',
        preview: 'Vista Previa',
        search: 'Ficheros',
        library: 'Biblioteca',
        session: 'Sesión',
        noResults: '-- Sin resultados --',
        shareableTitle: 'Por favor, confirme si estos ficheros tienen que ser compartibles o no:',
        shareableDescription: 'Por favor, seleccione, o no, la siguiente casilla dependiendo de si el fichero debe ser compartible o no',
        md5Title: 'Algunos ficheros ya existen en la biblioteca',
        md5Message: 'Los siguientes ficheros ya existen dentro de la biblioteca, ¿quiere subirlos otra vez?',
    },
    de: {
        uploadFileError: 'Fehler beim Hochladen',
        sameFileTypeError: 'Verschiedene Dateitypen',
        shareable: 'Teilbar',
        tags: 'Tags',
        updateFile: 'Datei aktualisieren',
        browseFiles: 'Dateien durchsuchen',
        delete: 'Löschen',
        deleteFile: 'Datei/en löschen',
        deleteFileMessage: 'Sind Sie sicher, dass Sie diese Datei löschen möchten?',
        deleteMultipleFilesMessage: 'Sind Sie sicher, dass Sie alle ausgewählten Dateien löschen möchten?',
        yes: 'Ja',
        no: 'Nein',
        saveBookmarkExplanation: 'Bitte geben Sie diesem Lesezeichen einen Namen',
        saveBookmarkNote: '* Sollte der Name bereits existieren, wird das aktuelle Lesezeichen überschrieben',
        cancel: 'Abbrechen',
        confirm: 'Bestätigen',
        mandatoryGroupFilter: 'verpflichtend, im Besitz der Gruppe des Metadokuments oder von niemandem',
        existingTags: 'Existierende Tags',
        uploadedBy: 'Hochgeladen von',
        me: 'Mir',
        userGroup: 'User-Gruppe',
        fileNameBeginsWith: 'Dateiname beginnt mit',
        searchPlaceholder: 'Suche…',
        file: 'Datei',
        image: 'Bild',
        video: 'Video',
        files: 'Dateien',
        images: 'Bilder',
        videos: 'Videos',
        mostUsedFiles: 'Meistgenutzte Dateien',
        savedSearches: 'Gespeicherte Suchen',
        sessions: 'Sitzungen',
        name: 'Name',
        use: 'Nutzung',
        date: 'Datum',
        menu: 'Menü',
        tagSelected: 'Ausgewählter Tag',
        deleteSelected: 'Auswahl löschen',
        chooseFile: 'Datei/en auswählen',
        loadMore: 'Weitere Ergebnisse laden',
        addUsergroup: 'User-Gruppe hinzufügen',
        dragDropZone: 'Drag & Drop-Bereich',
        upload: 'Hochladen',
        cancelAction: 'Abbruch',
        cancelActionMessage: 'Sind Sie sicher, dass Sie das Hochladen abbrechen wollen? Alle Änderungen gehen dabei verloren.',
        error: 'Fehler',
        uploadErrorMessage:
            'Um das Hochladen zu beginnen, müssen Sie mindestens eine Datei ausgewählt und mit mindestens einem Tag versehen haben.',
        ok: 'OK',
        createTag: 'Tag erstellen',
        tagFilesPlaceholder: 'Ihre Dateien mit Tags versehen',
        pleaseTagSelection: 'Bitte versehen Sie Ihre ausgewählten Dateien mit Tags',
        tagSelectedNote: '*Sollte ein Tag bei einer Datei wiederholt werden, wird er bei der erneuten Eingabe ignoriert',
        usedCount: 'Verwendete Anzahl',
        metadocument: 'Metadokumente',
        preview: 'Vorschau',
        search: 'Dateien',
        library: 'Bibliothek',
        session: 'Sitzung',
        noResults: '--Keine Ergebnisse--',
        shareableTitle: 'Bitte bestätigen Sie, ob diese Dateien teilbar sein müssen oder nicht',
        shareableDescription:
            'Bitte kreuzen Sie das untenstehende Kästchen an oder nicht, je nachdem, ob die Datei teilbar sein muss oder nicht',
        md5Title: 'Dateien bereits in der Bibliothek vorhanden',
        md5Message: 'Die folgenden Dateien sind bereits in der Bibliothek vorhanden - möchten Sie diese erneut hochladen?',
    },
    fr: {
        uploadFileError: 'Erreur téléchargement',
        sameFileTypeError: 'Type de fichier non identique',
        shareable: 'Partage',
        tags: 'Tags',
        updateFile: 'Mise  à jour fichier',
        browseFiles: 'Rechercher fichiers',
        delete: 'Effacer',
        deleteFile: 'Effacer fichier(s)',
        deleteFileMessage: 'êtes vous sûr de vouloir effacer ce fichier?',
        deleteMultipleFilesMessage: 'êtes vous sûr de vouloir effacer les fichiers sélectionnés?',
        yes: 'Oui',
        no: 'Non',
        saveBookmarkExplanation: 'Merci donner un nom à ce repertoire (tag)',
        saveBookmarkNote: 'si le nom existe déjà le repertoire (tag) existant sera écrasé',
        cancel: 'Annuler',
        confirm: 'Confirmer',
        mandatoryGroupFilter: 'Obligatoire, intégré à des Groupes de metadocument',
        existingTags: 'tags existants',
        uploadedBy: 'Ajouté par',
        me: 'moi',
        userGroup: "Groupe d'utilisateurs",
        fileNameBeginsWith: 'Le nom du fichier commence par',
        searchPlaceholder: 'Recherche...',
        file: 'Fichier',
        image: 'Image',
        video: 'Video',
        files: 'Fichier',
        images: 'Images',
        videos: 'Videos',
        mostUsedFiles: 'Fichiers les plus utilisés',
        savedSearches: 'Recherches sauvegardées',
        sessions: 'Sessions',
        name: 'Nom',
        use: 'Utilisateur',
        date: 'Date',
        menu: 'Menu',
        tagSelected: 'Tag Sélectionné',
        deleteSelected: 'Suppression sélectionnée',
        chooseFile: 'Choisissez fichier(s)',
        loadMore: 'Plus de résultats',
        addUsergroup: "Ajouter un groupe d'utilisateurs",
        dragDropZone: 'Drag & Drop area',
        upload: 'Charger',
        cancelAction: 'Annulation',
        cancelActionMessage: 'êtes-vous sûr de vouloir annuler le chargement ? Les données seront perdues.',
        error: 'Erreur',
        uploadErrorMessage:
            'Pour commencer à charger vous devez sélectionner au moins un fichier et comprenant au moins un tag défini pour chacun',
        ok: 'Ok',
        createTag: 'Créer tag',
        tagFilesPlaceholder: 'Taggez vos fichiers...',
        pleaseTagSelection: 'Merci tagger les fichiers sélectionnés',
        tagSelectedNote: 'Si un tag est répété deux sur un fichier il ne sera pas pris en compte pour ce fichier',
        usedCount: 'Compteur',
        metadocument: 'Metadocument',
        preview: 'Previsualisation',
        search: 'Fichiers',
        library: 'Bibliothèque',
        session: 'Session',
        noResults: '-- pas de résultat --',
        shareableTitle: 'Merci confirmer que ces fichiers pourront être partagés ou non',
        shareableDescription: 'Merci vérifier la liste ci-dessous, pour permettre le partage des fichiers',
        md5Title: 'Fichiers déjà existants dans la bibliothèque',
        md5Message: 'Les fichiers suivants existent déjà dans la bibliothèque, souhaitez vous les charger de nouveau?',
    },
});
